import { isIphone } from './browserHelpers';

let currentScrollPosition = 0;
let currentMarginTop = 0;
let isLocked = false;

interface Status {
  currentScrollPosition: number;
  currentMarginTop: number;
  isLocked: boolean;
}

const content = document.querySelector<HTMLElement>('.content');

function lockBodyScroll(skip?: boolean, skipOnIphone?: boolean): any {
  if (isLocked && skip) return;

  if (isLocked) {
    setTimeout(() => {
      const skipThisTime = true;
      lockBodyScroll(skipThisTime);
    }, 10);
    return;
  }

  currentScrollPosition = window.pageYOffset;
  currentMarginTop = parseInt(document.documentElement.style.getPropertyValue('margin-top'), 10) || 0;

  if (isIphone()) {
    if (!skipOnIphone) {
      document.documentElement.classList.add('ios-page-header-prevent-scroll-on-html');
      document.body.classList.add('ios-page-header-prevent-scroll-on-body');
    }
  } else {
    content?.style.setProperty('margin-top', `${currentMarginTop - currentScrollPosition}px`);
    document.documentElement.classList.add('page-header-prevent-body-scroll');
  }

  isLocked = true;
}

function unlockBodyScroll(skipOnIphone?: boolean): void {
  if (!isLocked) return;

  if (isIphone()) {
    if (!skipOnIphone) {
      document.documentElement.classList.remove('ios-page-header-prevent-scroll-on-html');
      document.body.classList.remove('ios-page-header-prevent-scroll-on-body');
    }
  } else {
    content?.style.setProperty('margin-top', `${currentMarginTop}px`);
    document.documentElement.classList.remove('page-header-prevent-body-scroll');
  }

  window.scrollTo(0, currentScrollPosition);

  currentScrollPosition = 0;

  isLocked = false;
}

function getBodyScrollStatus(): Status {
  return { currentScrollPosition, currentMarginTop, isLocked };
}

function simpleBodyScrollLock(shouldLock: boolean): void {
  if (shouldLock) {
    document.documentElement.style.setProperty('height', '100vh');
    document.documentElement.style.setProperty('overflow', 'hidden');
  } else {
    document.documentElement.style.removeProperty('height');
    document.documentElement.style.removeProperty('overflow');
  }
}

export { lockBodyScroll, unlockBodyScroll, getBodyScrollStatus, simpleBodyScrollLock };
